/** Figma `Switch`(Components, 6:216)의 status 축 */
export type SwitchStatus = 'default' | 'init' | 'loading';

type SwitchLook = 'off' | 'on' | 'disabled';

/** 트랙 면 */
export const TRACK_CLASS: Record<SwitchLook, string> = {
  off: 'bg-fg-placeholder',
  on: 'bg-bg-primary',
  disabled: 'bg-bg-disabled',
};

/**
 * 손잡이 면. 켜짐도 꺼짐과 같은 흰색(`bg.surface` = white, DD-25) — 예전 `on-primary`(neutral-950)는 검게 보였다.
 * 흰 손잡이 ↔ 트랙 `bg.primary`(primary-400) 대비 2.17:1 로 비텍스트 3:1(DD-3)에 못 미친다 — 사용자 결정(DD-25).
 */
export const KNOB_CLASS: Record<SwitchLook, string> = {
  off: 'bg-bg-surface',
  on: 'bg-bg-surface',
  disabled: 'bg-fg-disabled',
};

export function switchLook(checked: boolean, disabled: boolean): SwitchLook {
  if (disabled) return 'disabled';
  return checked ? 'on' : 'off';
}
